<template>
	<div
		class="rb-avatar mt-2"
		:class="{pulse: !sessionLoaded, login: loginEnabled, first: isFirst}"
		:style="style"
		@click="login"
	>
		<div class="login-text" v-if="loginEnabled">
			<rb-icon brand>facebook-f</rb-icon>
			<br>
			Login
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	import {oldApi} from '../app/oldApi';

	export default {
		name: 'RbAvatar',
		data: () => ({}),
		computed: {
			style() {
				return this.loggedUser ? {
					backgroundImage: `url(${this.loggedUser.AvatarUrl})`
				} : {}
			},
			loginEnabled() {
				return this.sessionLoaded && !this.loggedUser;
			},
			isFirst() {
				return this.loggedUser ? !!this.loggedUser.Status : false
			},
			...mapState([
				'loggedUser',
				'sessionLoaded'
			])
		},
		methods: {
			login() {
				if (this.loginEnabled) {
					window.location = oldApi.getUrl({
						url: 'Auth.FacebookLogin',
						params: {
							'origin-url': 'h'+window.location
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.rb-avatar {
		$size: $font-size-lg * 3;

		height: $size;
		width: $size;
		border-radius: 50%;
		border: rgba($highlight, .5) 1px solid;
		box-shadow: 0 0 5px rgba($highlight, .5);

		display: inline-block;
		position: relative;

		background-size: cover;
		background-position: center center;

		.login-text {
			text-align: center;
			font-size: $font-size-xs;
			opacity: 0;
			transition: all .3s ease;
			position: absolute;
			left: 0;
			right: 0;
			top: 50%;
			transform: translateY(-50%);
			color: $light;

			&:hover {
				color: $primary;
			}

			.rb-icon {
				font-size: 1.5em;
			}
		}

		&.login {
			cursor: pointer;
			border: rgba($primary, .7) 1px solid;
			box-shadow: 0 0 5px rgba($primary, .7);

			.login-text {
				opacity: 1;
			}
		}

		&.first {
			border: rgba($first, 1) 2px solid;
			//box-shadow: 0 0 5px rgba($first, 1);

			.login-text {
				opacity: 1;
			}
		}
	}

	.pulse {
		box-shadow: 0 0 0 rgba($highlight, 0.4);
		animation: pulse 2s infinite;
	}
	
	@keyframes pulse {
		0% {
			-moz-box-shadow: 0 0 0 0 rgba($highlight, 0.4);
			box-shadow: 0 0 0 0 rgba($highlight, 0.4);
		}
		70% {
			-moz-box-shadow: 0 0 0 10px rgba($highlight, 0);
			box-shadow: 0 0 0 10px rgba($highlight, 0);
		}
		100% {
			-moz-box-shadow: 0 0 0 0 rgba($highlight, 0);
			box-shadow: 0 0 0 0 rgba($highlight, 0);
		}
	}
</style>
